// 正则验证
export const verifyMethods = {
  phone: (val) => {
    return /^1\d{10}$/.test(val);
  },
  number: (val) => {
    return /^[0-9]*$/.test(val);
  },
  email: (val) => {
    return /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/.test(val);
  },
  strlen: (val, max) => {
    const len = val
      .replace(/\ud83c[\udf00-\udfff]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]/g, 'aa')
      .replace(/[^\x00-\xff]/g, 'aa').length;
    return len <= max;
  }
}

export const imageFileToDataURL = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function (evt) {
      const base64 = evt.target.result;
      const img = new Image();
      const canvas = document.createElement('canvas');
      console.log('reader onload');
      img.src = base64;
      img.onload = function () {
        console.log('img onload');
        const ratio = img.naturalWidth / img.naturalHeight; //  获取原图比例,为了等比压缩
          canvas.width = img.naturalWidth > 500 ? 750 : img.naturalWidth;
          canvas.height = canvas.width / ratio;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);    //  画在 canvas 上
          // 压缩后新图的 base64
          const zipBase64 = canvas.toDataURL();
          ctx.clearRect(0, 0, img.naturalWidth, img.naturalHeight);
          resolve(zipBase64);
      }
    };
    reader.readAsDataURL(file);
  });
}

export const dataURLtoBlob = (dataurl) => {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

// 获取url参数
export const getQueryString = name => {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};

// 百度统计上报事件
export const baiduTrackEvent = (events) => {
  console.log(['_trackEvent', ...events]);
  window._hmt && window._hmt.push(['_trackEvent', ...events]);
}

/**
 * 添加数据统计
 */
export const addStatistic = (analysis_type, analysis_code) => {
  if (analysis_code) {
    if (analysis_type === 'baidu') {
      (function (id) {
        const hm = document.createElement('script')
        hm.src = 'https://hm.baidu.com/hm.js?' + id
        const s = document.getElementsByTagName('script')[1]
        s.parentNode.insertBefore(hm, s)
      })(analysis_code)
      return false
    }
    if (analysis_type === 'google') {
      (function (i, s, o, g, r, a, m) { i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () { (i[r].q = i[r].q || []).push(arguments) }; i[r].l = 1 * new Date(); a = s.createElement(o); m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m) })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga')
    }
  }
}

// 判断是否微信环境
export const isWeixin = () => {  
  const ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {  
    return true;  
  } else {  
    return false;  
  }  
}

export const hexToRgba = (hex, al) => {
  let hexColor = /^#/.test(hex) ? hex.slice(1) : hex,
    alp = hex === 'transparent' ? 0 : Math.ceil(al),
    r, g, b;
  hexColor = /^[0-9a-f]{3}|[0-9a-f]{6}$/i.test(hexColor) ? hexColor : 'fffff';
  if (hexColor.length === 3) {
    hexColor = hexColor.replace(/(\w)(\w)(\w)/gi, '$1$1$2$2$3$3');
  }
  r = hexColor.slice(0, 2);
  g = hexColor.slice(2, 4);
  b = hexColor.slice(4, 6);
  r = parseInt(r, 16);
  g = parseInt(g, 16);
  b = parseInt(b, 16);
  return {
    hex: '#' + hexColor,
    alpha: alp,
    rgba: 'rgba(' + r + ', ' + g + ', ' + b + ', ' + (alp / 100).toFixed(2) + ')'
  };
};

export const removeQuery = (str, name) => {
  const reg = new RegExp(`&${name}(\=[^&]*)?(?=&|$)|^${name}(\=[^&]*)?(&|$)`);
  return str ? str.replace(reg, '') : '';
}

export const replaceByPath = (path) => {
  const base = process.env.NODE_ENV === "development" ? '' : '/addon/app-commonapply';
  let redirectUrl = `${window.location.origin}${base}${path}`;
  window.location.href = redirectUrl;
}

export const isWeixinImage = (url) => {
  return url && /(mmbiz|mmecoa)\.qpic\.cn/.test(url);
};

export const proxyWeixinImageFn = (url) => {
  if (isWeixinImage(url)) {
    return url.replace(/https?:\/\/(mmbiz|mmecoa)\.qpic\.cn/g, 'http://wxmedia-cdn.weixinhost.com');
  }
  return url;
};

export const getTextView = (content) => {
  const formatData = content && content.replace ? content.replace(/\n/g, '') : content;
  return formatData?.replace(/<[^>]+>/g, '') || '';
}